import Service from './service';
import logger from "../../logger";


export default class RouterService extends Service {

  constructor(service, address_details) {
    super(service);
    this.address_details = address_details;
    this.active_router_option = null;
    this.setPromoOrderSummaryStrings();
    logger.debug('router service', this.service);
  }

  setPromoOrderSummaryStrings() {
    for (let router_option of this.service.router_options) {
      for (let promo of router_option.billing.promos) {
        promo.legal_label = promo.description;
        if (promo.name.includes('_first_month_discount')) {
          promo.legal_description = 'XMission will automatically credit one FREE month of XMission XWi service ($12-15) to your account upon installation and activation. Limit of one per household. Applies to new XMission XWi customers only. One-time use only.'
        }
        else if (promo.name.includes('_xwi_discount')) {
          promo.legal_description = `XMission will automatically credit $${promo.rate} per month of XMission XWi service to your account upon installation and activation. Limit of one per household. Applies to new XMission customers only.`;
        }
      }
    }
  }

  routerOptions() {
    return this.service.router_options;
  }

  onlinePromo(router_option) {
    // only get the monthly promo
    let promos = router_option.billing.promos.filter(x => x.featured);
    if (promos.length === 1){
      return promos[0];
    }
    return null;
  }
  setActiveRouterOption(speed_id) {
    let router_option = this.routerOptions().filter(x => (x.speed_id === speed_id));
    this.active_router_option = router_option.length === 1 ? router_option[0] : null;
    logger.debug('router options', this.routerOptions())
  }

  getActiveRouterOption() {
    return this.active_router_option;
  }

  grossMonthlyRate(){
    // for now, we assume there is only one
    return this.active_router_option.billing.prices[0].rate;
  }

  addActiveRouterOptionToCart() {
    this.order_summary.addServiceOptionToCart(this.active_router_option);
  }

  addMeshOptionToCart() {
    this.order_summary.addServiceOptionToCart(this.service.mesh_option);
  }

  removeRouterOptionFromCart() {
    this.order_summary.removeServiceOptionFromCart(this.active_router_option);
  }

  removeMeshOptionFromCart() {
    logger.debug('removeMeshOptionFromCart', this.service.mesh_option)
    this.order_summary.removeServiceOptionFromCart(this.service.mesh_option);
  }

  activeRouterAvailable() {
    if (this.active_router_option === null) {
      return false;
    }
    return this.active_router_option.router_available;
  }

  meshesAvailable() {
    logger.debug('router service asdf', this.service)
    return this.service.mesh_option.quantity_available;
  }

  meshMonthlyRate() {
    return this.service.mesh_option.billing.prices[0].rate;
  }

}



// WEBPACK FOOTER //
// ./src/lib/ssu/input_models/router-service.js